module.exports = __webpack_public_path__ + "img/iphone-x-mockup (14).2cf5f420.png";